import { Outlet, useLocation, useNavigation } from "react-router-dom";
import Navbar from "./components/NavBar/Navbar";
import Footer from "./components/Footer";
import { Suspense } from "react";
import Spinner from "./components/UI/Spinner";
import ScrollToTop from "./hooks/ScrollToTop";
import BottomNav from "./components/NavBar/BottomNav";

const Layout = () => {
  const location = useLocation();
  const navigation = useNavigation();

  const isHome = location.pathname === "/"; // ✅ detect home page
  const isLoading = navigation.state === "loading"; // ✅ detect loader in progress

  return (
    <>
      <ScrollToTop />
      <Navbar
        homeCSS={isHome ? "bg-transparent absolute top-0 left-0 z-50" : "sticky top-0 z-50"}
      />
      <main>
        {/* ✅ Show spinner when navigating between routes (loader fetching) */}
        {isLoading && (
          <div className="fixed inset-0 flex justify-center items-center bg-gray-950/70 z-50">
            <Spinner />
          </div>
        )}
        <Suspense
          fallback={
            <div className="flex justify-center items-center h-screen bg-gray-950">
              <Spinner />
            </div>
          }
        >
      

          <Outlet />
   
        </Suspense>
        {/* <div className="overflow-x-hidden max-w-[100vw]"> */}
        <BottomNav />
        {/* </div> */}
      </main>

      <Footer />
    </>
  );
};

export default Layout;
